import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes: {
            light: {
                primary: "#d90000",
                primaryLight: "#d90000",
                primaryVariant:"#00ccff",
                secondary: "#5cb85c",
                secondaryVariant: "#013f4e",
                accent: "#013f4e",
                error: "#f44336",
                warning: "#ff9800",
                info: "#339999",
                success: "#4caf50",
                blend: "#ecf1f4",
                lightgray:"#f5f5f5",
                darkgray:"#9b9b9b",
                darkergray:"#4d4d4d",
                darkergray2:"#4b4b4b",
                lightBackground: "#eff1f7",
                lightPinkBackground: "#f6f3f1",
                darkPinkBackground: '#F0DFD4',
                availableToday: '#01a400',
                blueBg:'#f4f9ff'
            }
        }
    }
});
